// Conversion entre hora decimal de 24h y el formato "HH:MM AM/PM" usado por el selector.

export const decimalToTime = (index: number): string => {
  let hour = Math.floor(index);
  const frac = Number((index - hour).toFixed(2));
  const minutes =
    frac === 0 ? "00" : frac === 0.25 ? "15" : frac === 0.5 ? "30" : "45";
  const period = index < 12 ? "AM" : "PM";
  if (hour === 0) hour = 12;
  else if (hour > 12) hour = hour - 12;
  return `${hour.toString().padStart(2, "0")}:${minutes} ${period}`;
};

// "07:00 AM" / "09:45 PM" -> decimal 24h. Devuelve null si el formato no es valido.
export const timeToDecimal = (value: string): number | null => {
  if (!value || typeof value !== "string") return null;
  const match = value.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!match) return null;
  let hour = Number(match[1]);
  const minutes = Number(match[2]);
  const period = match[3].toUpperCase();
  if (period === "PM" && hour !== 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return Number((hour + minutes / 60).toFixed(2));
};
